import React from 'react';
import SiteSearchImage from './SiteSearchImage';
import Link from '../common/TrackedLink';
import renderHTML from 'react-render-html';
import {pushSearchResultsItem} from "../../utils/datalayer";

const ProductsSiteSearch = ({ product, keyword }) => {
	return (
		<li className="results-list-item">
			<SiteSearchImage imageName={ product.imageName } />
			<div>
				<h2>SentrySafe { product.skuNumber } { product.description }</h2>
				<p>{ renderHTML(product.longDescription) }</p>
				<Link
					className="arrow-link"
					to={ `/product/${product.skuNumber}` }
					onClick={(e) => {pushSearchResultsItem(e, keyword)}}>Shop Now</Link>
			</div>
		</li>
	);
};

export default ProductsSiteSearch;


// WEBPACK FOOTER //
// ./src/pages/sitesearch/ProductsSiteSearch.js